import { API } from '../CommonFunc/amplifyApiCompat';
import { dataConversionApiConsts } from './Const';
import { CTGAlphaLISAPutApiRequest, IC50BindingPutApiRequest, PutApiResponse } from './ApiModels';

export class DataConversionApiClient {
    
    /**
     * Convert CTG or AlphaLISA 96/384 well plate data
     */
    static async convertCTGAlphaLISA(req: CTGAlphaLISAPutApiRequest): Promise<PutApiResponse> {
        return API.put(dataConversionApiConsts.API_NAME, dataConversionApiConsts.path.CONVERT_CTG_ALPHALISA, {
            headers: {
                'Content-Type': 'application/json',
            },
            body: req
        });
    }

    /**
     * Convert IC50 Binding data
     */
    static async convertIC50Binding(req: IC50BindingPutApiRequest): Promise<PutApiResponse> {
        return API.put(dataConversionApiConsts.API_NAME, dataConversionApiConsts.path.CONVERT_IC50_BINDING, {
            headers: {
                'Content-Type': 'application/json',
            },
            body: req
        });
    }
}
